import React from 'react'
import { OverlayTrigger, Tooltip, Tab, Tabs, Table } from 'react-bootstrap'
import { v4 as uuidv4 } from 'uuid'

const FanGrowth = ({ title, data, brandArr }) => {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      追蹤粉絲數量變化，分析您粉絲專頁的受歡迎程度和影響力、掌握成長趨勢。
    </Tooltip>
  )
  return (
    <>
      <h4 className="fw-bolder p-3">
        {title}
        <OverlayTrigger
          placement="right"
          delay={{ show: 50, hide: 400 }}
          overlay={renderTooltip}
        >
          <div className="fas fa-question-circle p-1 text-decoration-none"></div>
        </OverlayTrigger>
      </h4>
      <Tabs
        defaultActiveKey="Facebook"
        id="justify-tab-example"
        className="mb-3"
        justify
      >
        {brandArr.map((v) => {
          return (
            <Tab key={uuidv4()} eventKey={v.title} title={v.title}>
              <Table striped hover>
                <tbody>
                  <tr>
                    <td>近 7 日累積新粉數</td>
                    <td>{data[`fans_accm_7d_${v.brand}`]} 人</td>
                  </tr>
                  <tr>
                    <td>近 30 日累積新粉數</td>
                    <td>{data[`fans_accm_30d_${v.brand}`]} 人</td>
                  </tr>
                </tbody>
              </Table>
            </Tab>
          )
        })}
      </Tabs>
    </>
  )
}

export default FanGrowth
